module.exports = __webpack_public_path__ + "static/media/way-of-using-bizbook.84042883.png";